import { styled, theme } from '@clickcease/cc-client-components-lib'
import { OVERPOPULATED_PARAMETER } from '../features/MultiDomainInput'

const {
  colors: {
    tableSelected: { value: tableSelectedColor },
    tableHovered: { value: tableHoveredColor },
    buttonPressed: { value: buttonPressedColor },
    darkGray: { value: darkGrayColor },
    lightGray: { value: lightGrayColor },
    veryLightGray: { value: veryLightGrayColor },
    disabled: { value: disabledColor },
  },
  fontWeights: {
    r: { value: fontWeightR },
  },
  fontSizes: {
    md: { value: mdFontSize },
  },
  space: {
    4: { value: space4 },
  },
  fonts: {
    regular: { value: regularFont },
  },
  radii: {
    normal: { value: normalRadius },
  },
} = theme

export const AddDomainWrapper = styled('div', {
  height: '550px',
  variants: {
    isMultiDomain: {
      true: {
        height: '550px',
      },
      false: {
        height: '250px',
      },
    },
  },
})

export const AddDomainModalStyled = styled('div', {
  borderRadius: '$medium',
  width: '527px',
  height: '160px',
  background: '#FFFFFF',
  fontFamily: regularFont,
  zIndex: '10',
  display: 'flex',
  flexDirection: 'column',
})

export const AddDomainContainer = styled('div', {
  padding: '$10 $10 $10 $9',
})

export const SelectProductTitle = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '$8',
})

export const SelectProductContainer = styled('div', {
  width: '70%',
  padding: '$10 $10 $10 $9',

  variants: {
    noPadding: {
      true: {
        padding: '0px',
        width: '100%',
      },
    },
  },
})

export const AddDomainModalDescription = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
})

export const InputError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$sm',
  position: 'absolute',
  bottom: '-20px',
  left: '0px',
})

export const DomainModalError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$sm',
  marginTop: '10px',
})

export const AddDomainModalInput = styled('div', {
  width: '100%',
  color: lightGrayColor,
  fontWeight: '$l',
  fontSize: '$md',
  marginTop: '15px',
  fontFamily: regularFont,
  border: '0px solid blue',
  borderRadius: normalRadius,
  outline: 'none',
  position: 'relative',

  ['div']: {
    outline: 'none',
  },
})

export const AddDomainInputStyle = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  control: (baseStyles) => ({
    ...baseStyles,
    border: `solid 1px ${lightGrayColor}`,
    borderRadius: normalRadius,
    outline: 'none',
  }),
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: regularFont,
    fontWeight: fontWeightR,
    fontSize: mdFontSize,
  }),
  multiValue: (baseStyles, { data }) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
    const defaultStyle = {
      ...baseStyles,
      color: buttonPressedColor,
      background: tableHoveredColor,
      fontFamily: regularFont,
      borderRadius: normalRadius,
      fontWeight: fontWeightR,
      fontSize: mdFontSize,
      paddingTop: 0,
      marginRight: space4,
      border: `solid 1px ${tableSelectedColor}`,
      div: {
        color: buttonPressedColor,
      },
      '[role=button]': {
        background: tableHoveredColor,
        color: buttonPressedColor,
        ':hover': {
          cursor: 'pointer',
          background: 'unset',
        },
      },
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const overpopulatedStyle = {
      ...defaultStyle,
      borderColor: disabledColor,
      background: veryLightGrayColor,
      color: darkGrayColor,
      div: {
        color: darkGrayColor,
      },
      '[role=button]': {
        background: veryLightGrayColor,
        ':hover': {
          cursor: 'pointer',
          background: 'unset',
        },
      },
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return data[OVERPOPULATED_PARAMETER] ? overpopulatedStyle : defaultStyle
  },
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    paddingTop: 0,
  }),
}
